import {DavProperty, VCardContactData} from "../services/messages/VCardContactData";

export type KnownDavPropertyNames =
    | "ADR"
    | "AGENT"
    | "ANNIVERSARY"
    | "BDAY"
    | "CALADRURI"
    | "CALURI"
    | "CATEGORIES"
    | "CLASS"
    | "CLIENTPIDMAP"
    | "CREATED"
    | "EMAIL"
    | "FBURL"
    | "FN"
    | "GENDER"
    | "GEO"
    | "GRAMGENDER"
    | "IMPP"
    | "KEY"
    | "KIND"
    | "LABEL"
    | "LANG"
    | "LANGUAGE"
    | "PRONOUNS"
    | "LOGO"
    | "MAILER"
    | "MEMBER"
    | "N"
    | "NAME"
    | "NICKNAME"
    | "NOTE"
    | "ORG"
    | "PHOTO"
    | "PRODID"
    | "PROFILE"
    | "RELATED"
    | "REV"
    | "ROLE"
    | "SOCIALPROFILE"
    | "SORT-STRING"
    | "SOUND"
    | "SOURCE"
    | "TEL"
    | "TITLE"
    | "TZ"
    | "UID"
    | "URL"
    | "VERSION"
    | "XML";

export const KnownDavDisplayNames: Record<string, string> = {
    ADR: "Address",
    BDAY: "Birthday",
    FN: "Full Name",
    N: "Name",
    REV: "Last Update Time",
    TEL: "Phone",
};

export function getDavPropertyValue(davContact: VCardContactData, propertyName: KnownDavPropertyNames): string | undefined {
    return decodeDavPropertyValue(davContact.props[propertyName]?.[0]);
}

export function getDavMultiPropertyValue(property: DavProperty | undefined): string[] {
    if (!property) {
        return [];
    }
    return decodeDavPropertyValue(property).split(/;|\r?\n/g).filter(t => !!t) ?? [];
}

export function decodeDavPropertyValue(property: DavProperty | undefined): string {
    if (!property?.value) {
        return "";
    }
    // TODO: deal with encoding types etc.
    return property.value;
}
// TODO: add tests